<template>
  <s-modal
    v-model="showModal"
    title=""
    ok-only
    size="lg"
    :ok-title="$t('actions.close')"
    @ok="closeModal"
  >
    <template #modal-header>
      <engineering-modules-modal-header
        :title="$t('asset-list.asset-digital-network')"
        :company="company"
        :regional="regional"
        :installation="installation"
        :asset="asset"
        :showUpdateIcon="true"
        :showPrintIcon="true"
      />
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="closeModal"
      >
        ×
      </button>
    </template>
    <b-container fluid>
      <b-row align-h="end">
        <b-form-group>
          <b-form-radio-group
            class="mt-2 sm-mt-0"
            v-model="viewType"
            buttons
            button-variant="outline-primary"
            size="sm"
            :checked="viewType"
            :options="viewTypes"
          />
        </b-form-group>
      </b-row>
      <b-row>
        <modules-view-panel
          v-if="showData"
          class="p-0 mt-3"
          :modules="assets"
          :view-mode="viewType"
        />
        <s-empty-list
          v-else
          class="w-100"
          :loading="loading"
        />
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import loadingMixin from '@/services/loadingMixin';
import SupervisionService from '@/domain/services/installation/supervision/supervision';
import EngineeringModulesModalHeader from '@/components/header/EngineeringModulesModalHeader';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineeringModulesHeader';
import ModulesViewPanel
  from '@/domain/components/generalPanel/mySigma/digitalNetwork/ModulesViewPanel';

export default {
  name: 'DigitalNetworkModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    assetId: {
      type: String,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
    installation: {
      type: String,
      default: '',
    },
    regional: {
      type: String,
      default: '',
    },
    asset: {
      type: String,
      default: '',
    },
  },
  components: {
    EngineeringModulesModalHeader,
    ModulesViewPanel,
  },
  mixins: [
    loadingMixin,
  ],
  data: () => ({
    viewType: 'list',
    assets: null,
    events,
  }),
  computed: {
    viewTypes() {
      return [
        {
          text: this.$t('supervision.digital-network.grid'),
          value: 'grid',
        },
        {
          text: this.$t('supervision.digital-network.list'),
          value: 'list',
        },
      ];
    },
    showData() {
      return !!(this.assets || []).length;
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.loadDigitalNetwork();
    this.initListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    initListeners() {
      eventBus.on(events.refresh, this.loadDigitalNetwork);
    },
    removeListeners() {
      eventBus.off(events.refresh, this.loadDigitalNetwork);
    },
    async loadDigitalNetwork() {
      this.assets = null;
      this.startLoading();
      try {
        this.assets = await SupervisionService.getDigitalNetwork(this.assetId);
      } finally {
        this.endLoading();
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .modal-header
  display: block

.close
  position: absolute
  top: 1rem
  right: 1rem

.network-status
  &__button
    width: 120px
    white-space: nowrap

@page
  margin: 0 auto

::v-deep
  .default-engineering-modules-header__column-title
    & h1
      text-transform: uppercase

  @media print
    .modal-dialog,
    .modal-content
      max-width: 100vw
      width: 100vw
      height: 100vh
      margin: 0 auto

    .modal-content
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
</style>
